
import { CityPageTemplate } from '@/components/seo/CityPageTemplate';
import { Plane, Building, Truck } from 'lucide-react';

const AtlantaPage = () => {
  return (
    <CityPageTemplate
      city="Atlanta"
      state="Georgia"
      stateAbbr="GA"
      population="490,000+"
      majorIndustries={["transportation", "technology", "financial services", "healthcare", "film production"]}
      businessChallenges={[
        "Major transportation hub workforce management",
        "Film industry project-based employment",
        "Fortune 500 headquarters complex HR needs",
        "Rapid tech sector growth and talent competition",
        "Multi-state operations coordination"
      ]}
      peoSolutions={[
        "Transportation industry specialized HR services",
        "Entertainment industry project-based HR solutions",
        "Enterprise-level HR support for large corporations",
        "Tech sector talent attraction and retention programs",
        "Multi-state payroll and compliance management"
      ]}
      localBusinessTypes={[
        { name: "Transportation", description: "Airlines, logistics, railroads, trucking" },
        { name: "Technology", description: "Fintech, software, telecommunications" },
        { name: "Financial Services", description: "Banking, insurance, investment" },
        { name: "Film Production", description: "Studios, production companies, post-production" }
      ]}
      metaDescription="Find the best PEOs in Atlanta with The PEO App. Compare quotes from top Atlanta Professional Employer Organizations offering specialized HR solutions for transportation, technology, and film production industries."
      keyFeatures={[
        {
          icon: Plane,
          title: "Transportation Hub Expertise",
          description: "Specialized HR solutions for Atlanta's role as a major transportation and logistics hub with airline and cargo industry support."
        },
        {
          icon: Building,
          title: "Fortune 500 Support",
          description: "Enterprise-level HR services for Atlanta's numerous Fortune 500 headquarters with complex multi-location needs."
        },
        {
          icon: Truck,
          title: "Film Industry Solutions",
          description: "Expert HR services for Atlanta's booming film and television production industry with project-based employment support."
        }
      ]}
    />
  );
};

export default AtlantaPage;
